export const multiColorSwatch =
  'background: linear-gradient(45deg, red, orange, yellow, green, blue, indigo, violet, red);';
